(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["old-dog-new-tricks"] && !Shopify.designMode) return;
  try {
    
(function () {
  function activate(facade) {
    if (facade.classList.contains('odnt-media--playing')) return;
    var id = facade.getAttribute('data-ytid');
    if (!id) return;
    var iframe = document.createElement('iframe');
    iframe.setAttribute(
      'src',
      'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0'
    );
    iframe.setAttribute('title', facade.getAttribute('aria-label') || 'YouTube video player');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');
    facade.innerHTML = '';
    facade.appendChild(iframe);
    facade.classList.add('odnt-media--playing');
  }

  document.querySelectorAll('.odnt .odnt-facade').forEach(function (facade) {
    facade.addEventListener('click', function () {
      activate(facade);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
